<template>
  <div class="choose-order">
    <app-header title="选择订单" @goback="goBack">
      <div slot="tips" @click="confirm">
        <div class="header-right">确定</div>
      </div>
    </app-header>
    <pull-to :is-top-bounce="false" :is-bottom-bounce="isLoadAll" :bottom-load-method="loadmore">
      <ul class="order-list">
        <li v-for="(item, index) in orderList" :key="index" @click="selectIt(item)" :class="{'select-li': item.id === currentOrder.id}">
          <div>{{item.productName}}</div>
          <div class="sp-num">{{`剩余名额：${item.surplusNum}`}}</div>
        </li>
      </ul>
    </pull-to>
  </div>
</template>

<script>
import apis from 'api/index';
import { commonMixin } from 'common/js/mixin';
import PullTo from 'vue-pull-to';

export default {
  mixins: [commonMixin],
  components: {
    PullTo
  },
  data() {
    return {
      orderList: [],
      pageNumber: 1,
      pageSize: 15,
      total: 0,
      currentOrder: {},
    }
  },
  computed: {
    isLoadAll() {
      return Boolean(this.total > this.pageNumber * this.pageSize);
    },
  },
  created() {
    this.fetchOrderList();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    selectIt(item) {
      this.currentOrder = item;
    },
    async confirm() {
      if(JSON.stringify(this.currentOrder) === '{}') {
        this.showToast('请选择订单', 'warn');
        return false;
      }
      if(this.currentOrder.surplusNum === 0) {
        this.showToast('订单的剩余名额不可为零', 'warn');
        return false;
      }
      try {
        let params = {
          ids: [this.$route.params.id],
          status: 4,
          moduleOrderId: this.currentOrder.id
        }
        const res = await apis.updateRenewType(params);
        this.showDialog('激活成功','alert' , () => {
          this.$router.go(-1);
        });
      } catch(err) {
        console.error(err);
      }
    },
    loadmore(loaded) {
      if(this.total <= this.pageNumber * this.pageSize) {
        return false;
      }
      this.pageNumber +=1;
      this.fetchOrderList().then(res => {
        loaded('done');
      });
    },
    async fetchOrderList() {
      try {
        let params = {
          no: this.pageNumber,
          limit: this.pageSize,
          status: 5
        }
        const res = await apis.ordersModuleOrder(params);
        this.orderList = this.orderList.concat(res.records);
        this.total = res.total;
      } catch(err) {
        console.error(err);
      }
    }
  }
}
</script>


<style src="./index.scss" lang="scss" scoped></style>
